import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import Pricing from "@/pages/Pricing";
import ScheduledPricing from "@/pages/ScheduledPricing";
import KdvReview from "@/pages/KdvReview";
import PriceHistory from "@/pages/PriceHistory";
import { useAuth } from "@/context/AuthContext";
import { CircleDollarSign, Percent, History, Clock } from "lucide-react";

export default function PriceManagement() {
  const { can } = useAuth();
  const [sp, setSp] = useSearchParams();
  const TABS = [
    ...(can("price.write") ? [["toplu", "Toplu Fiyatlandırma", CircleDollarSign]] : []),
    ...(can("price.write") ? [["zamanli", "Zam & İndirim", Clock]] : []),
    ...(can("price.read") ? [["kdv", "KDV Doğrulama", Percent]] : []),
    ...(can("price.write") ? [["gecmis", "Fiyat Geçmişi", History]] : []),
  ];
  const wanted = sp.get("tab");
  const initial = wanted && TABS.find((t) => t[0] === wanted) ? wanted : (TABS[0]?.[0] || "kdv");
  const [tab, setTab] = useState(initial);
  const go = (k) => { setTab(k); setSp({ tab: k }, { replace: true }); };

  return (
    <div className="space-y-5 fade-in" data-testid="price-management-page">
      <div>
        <h1 className="flex items-center gap-2 font-heading text-2xl font-bold text-slate-900">
          <CircleDollarSign className="h-6 w-6 text-brand-green" /> Fiyat Yönetimi
        </h1>
        <p className="mt-1 text-sm text-slate-500">Toplu fiyatlandırma, zamanlı zam/indirim, KDV doğrulama ve fiyat geçmişi — hepsi tek modülde, sekme sekme.</p>
      </div>
      <div className="inline-flex flex-wrap gap-1 rounded-lg bg-slate-100 p-1" data-testid="pm-tabs">
        {TABS.map(([k, l, Icon]) => (
          <button key={k} data-testid={`pm-tab-${k}`} onClick={() => go(k)}
            className={`flex items-center gap-1.5 rounded-md px-3.5 py-1.5 text-sm font-semibold transition-colors ${tab === k ? "bg-white text-brand-green shadow-sm" : "text-slate-500 hover:text-slate-700"}`}>
            <Icon className="h-4 w-4" /> {l}
          </button>
        ))}
      </div>
      {tab === "toplu" && <Pricing />}
      {tab === "zamanli" && <ScheduledPricing />}
      {tab === "kdv" && <KdvReview />}
      {tab === "gecmis" && <PriceHistory />}
    </div>
  );
}
